import { createContext } from 'react'
import type { TerrosHeaderMetadata } from '@terros/common'

export const HeadersContext = createContext<TerrosHeaderMetadata | undefined>(undefined)
